module.exports = __webpack_public_path__ + "img/page7-bg.4f83839d.png";